import * as Immutable from 'immutable'
import { RouteVariable, RouteInputOf, RouteInput, Route, RouteOutput, RoutesOutput } from '../types/types';

export const ToGraphqlVariable = <K extends {[_: string] : Route}>(routeInputs : RouteInputOf<K>) : RouteVariable<K>[] =>  {
  const dict = Immutable.Map<keyof K, RouteInput>(routeInputs);
  return dict.filter(v => !!v).map((k, v) => {
    return {
      name: k.name,
      args: k.args,
      identifier: v,
      locale: k.locale
    }
  }).toArray()
}


export const ToDictionary = <K extends {[_:string] : Route}>(routeInputs : RouteOutput<K>[]) : RoutesOutput<K> =>  {
  return Immutable.List(routeInputs).
    groupBy<keyof K>(x => x.identifier).
    map(x => x.first()).
    map<RouteOutput<K>>(x => {
      return {
        url: x.url,
        path: x.path,
        name: x.name,
        identifier: x.identifier
      }
    }).toMap()
}
